import React from "react";
// import { withRouter } from "react-router-dom";
import AdminNavbar from "../../../components/Admin/adminNavbar";
import AddProduct from "./addProduct";
import { connect } from "react-redux";
import AuthAdmin from "../../../components/AuthAdmin/AuthAdmin";
import Spinner from "../../../components/Spinner/Spinner";
import { productData } from "../../../data";

const Products = (props) => { 
  // let serviceId = this.props.location.state.serviceId;
  // let categoryName = this.props.location.state.categoryName;
  //editProduct={productData[0]}
  let {isAuthenticated,admin,staff,userId} = props;
    if(localStorage.getItem("idToken")){
      if(userId == null && admin == null && staff==null){
        return <Spinner/>
      }
    }

    if(!isAuthenticated || !(admin||staff)){
      return <AuthAdmin/>
    }

  return (
    <React.Fragment> 
      <AdminNavbar />
      
      <AddProduct />
      {/* <ProductList serviceId={serviceId} categoryName={categoryName} /> */}
    </React.Fragment>
  );
};

//"0b69b093d7b8cdabab64719d7016f6c1OrangeSc2d1a40fe6a9"  SOr

const mapStateToProps = (state) => {
  return {
    isAuthenticated:state.auth.userId!=null,
    admin:state.auth.admin,
    staff:state.auth.staff,
    userId:state.auth.userId
  };
};

export default connect(mapStateToProps, null)(Products);
